const configuraciones = {
  // URL_API: 'http://delcampoagapi.com.mx/api/v1', // Producción
  // URL_API: 'http://localhost:3001/api/v1', // Desarrollo
  // URL_API: 'http://192.168.3.58:3001/api/v1', // Desarrollo
  ELEMENTOS_POR_PAGINA: 11,  
};

export default configuraciones;
